import { Box, useBreakpointValue } from "@chakra-ui/react";
import { useMemo } from "react";
import {
  ContentResource,
  useContents
} from "~/api/resources";
import { Subheading } from "~/components/Text";
import { Carousel } from "../Carousel";
import { StoryCard } from "./StoryCard";

const RECORD_TYPE_MAP: Record<string, ContentResource> = {
  Regions: "Region",
  Region: "Region",
  Itineraries: "Itinerary",
  Itinerary: "Itinerary",
  Listings: "Listing",
  Listing: "Listing",
};

type Props = {
  title?: string;
  tags?: number[];
  story_id?: number | string;
  recordId?: number;
  recordType?: string;
  filterByPage?: boolean;
};

export const StoryCardCarousel = ({
  title = "Related Stories",
  tags,
  story_id,
  recordId,
  recordType,
}: Props) => {
  const resource = recordType ? RECORD_TYPE_MAP[recordType] : undefined;
  const useResourceStories = !!recordId && !!resource;

  const { records: taggedStories, isSuccess: allSuccess } = useContents(
    "stories",
    { per_page: 12, sort: "created_at", order: "desc", filter: { tags: { id: tags } } },
    { enabled: !useResourceStories },
  );


  const stories = useMemo(() => {
    return taggedStories?.filter((story) => String(story.id) !== String(story_id));
  }, [taggedStories, story_id]);

  const showNav = useBreakpointValue({ base: false, lg: true });


  if (!stories.length || !allSuccess) return null;

  return (
    <Box px={{ base: 2, lg: 24 }}>
      <Subheading
        size={{ base: "lg", md: "xl" }}
        textTransform="uppercase"
        maxWidth={"90vw"}
        textAlign="center"
        mb={8}
        mt={8}
      >
        {title}
      </Subheading>
      <Carousel showNav={showNav}>
        {stories.map((story) => (
          <StoryCard key={story.id} story={story} />
        ))}
      </Carousel>
    </Box>
  );
};
